import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter, useLocation } from 'react-router-dom';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { App } from './App';
// ----- PostHog -----
posthog.init('phc_s2ttCsPkfXgEWhZvPb8ffPxWu5bdm6WkmZk7zv9Pn6fJ', {
  api_host: 'https://us.i.posthog.com',
  capture_pageview: 'history_change',
  capture_pageleave: true,
  autocapture: true,
  session_recording: {
    maskAllInputs: false,
    maskTextSelector: '[data-private]'
  }
});
// ----- Meta Pixel (global — runs once at app boot, equivalent to placing the snippet in <head>) -----
const META_PIXEL_ID = '9739183832863609';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
;
(function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return;
  const n: any = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
})();
// Fire Meta PageView on every SPA route change (since fbevents.js doesn't auto-track SPA navigations)
function MetaPixelRouteTracker() {
  const location = useLocation();
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname]);
  return null;
}
render(<PostHogProvider client={posthog} data-id="element-141">
    <BrowserRouter data-id="element-142">
      <MetaPixelRouteTracker data-id="element-143" />
      <App data-id="element-144" />
    </BrowserRouter>
  </PostHogProvider>, document.getElementById('root'));